import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AffiliateApiService } from '../../service/affiliateApiService';
import { useLoader } from '../../base/context/LoaderProvider';
import { ToastTypes, useMessage } from '../../base/context/MessageProvider';
import './affiliate.css';

export default function AffiliateProfile() {
  const [profile, setProfile] = useState(null);
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    pan: '',
    bankAccountNumber: '',
    bankIfscCode: '',
    bankAccountHolderName: '',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const loader = useLoader();
  const message = useMessage();
  const navigate = useNavigate();

  useEffect(() => {
    loader.showLoading(true);
    AffiliateApiService.getProfile()
      .then((res) => {
        loader.showLoading(false);
        if (res.status?.code === 200 && res.data) {
          setProfile(res.data);
          setForm({
            firstName: res.data.firstName || '',
            lastName: res.data.lastName || '',
            phone: res.data.phone || '',
            pan: res.data.pan || '',
            bankAccountNumber: res.data.bankAccountNumber || '',
            bankIfscCode: res.data.bankIfscCode || '',
            bankAccountHolderName: res.data.bankAccountHolderName || '',
          });
        } else {
          setError(res.error?.message || 'Failed to load');
        }
      })
      .catch((err) => {
        loader.showLoading(false);
        if (err?.status === 403) {
          navigate('/', { replace: true });
          return;
        }
        setError(err?.message || 'Failed to load');
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSaving(true);
    AffiliateApiService.updateProfile(form)
      .then((res) => {
        setSaving(false);
        if (res.status?.code === 200) {
          message.showToast('Profile updated', ToastTypes.SUCCESS);
          setProfile(res.data);
        } else {
          message.showToast(res.error?.message || 'Update failed', ToastTypes.ERROR);
        }
      })
      .catch((err) => {
        setSaving(false);
        message.showToast(err?.message || 'Update failed', ToastTypes.ERROR);
      });
  };

  if (error && !profile) {
    return (
      <div className="affiliate-page">
        <h1 className="affiliate-welcome">Profile</h1>
        <p className="affiliate-error">{error}</p>
      </div>
    );
  }

  if (!profile) return null;

  return (
    <div className="affiliate-page">
      <h1 className="affiliate-welcome">Profile</h1>
      <p className="affiliate-subtitle">Personal and bank details for payouts. Email is read-only.</p>

      {profile.affiliateReferralCode && (
        <div className="affiliate-referral-section">
          <h2 className="affiliate-section-title">Referral code</h2>
          <div className="affiliate-referral-code-box">
            Your code: <strong>{(profile.affiliateReferralCode || '').toUpperCase()}</strong>
          </div>
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="affiliate-profile-grid">
          <div className="affiliate-profile-section">
            <h3>Personal</h3>
            <div className="affiliate-form-group">
              <label>Email</label>
              <input type="email" value={profile.email || ''} readOnly />
            </div>
            <div className="affiliate-form-group">
              <label>First name</label>
              <input name="firstName" value={form.firstName} onChange={handleChange} placeholder="First name" />
            </div>
            <div className="affiliate-form-group">
              <label>Last name</label>
              <input name="lastName" value={form.lastName} onChange={handleChange} placeholder="Last name" />
            </div>
            <div className="affiliate-form-group">
              <label>Phone</label>
              <input name="phone" value={form.phone} onChange={handleChange} placeholder="Phone" />
            </div>
            <div className="affiliate-form-group">
              <label>PAN</label>
              <input name="pan" value={form.pan} onChange={handleChange} placeholder="PAN number" />
            </div>
          </div>
          <div className="affiliate-profile-section">
            <h3>Bank details (for withdrawals)</h3>
            <div className="affiliate-form-group">
              <label>Account holder name</label>
              <input name="bankAccountHolderName" value={form.bankAccountHolderName} onChange={handleChange} placeholder="As per bank record" />
            </div>
            <div className="affiliate-form-group">
              <label>Account number</label>
              <input name="bankAccountNumber" value={form.bankAccountNumber} onChange={handleChange} placeholder="Bank account number" />
            </div>
            <div className="affiliate-form-group">
              <label>IFSC code</label>
              <input name="bankIfscCode" value={form.bankIfscCode} onChange={handleChange} placeholder="IFSC" />
            </div>
          </div>
        </div>
        <div style={{ marginTop: '1.5rem' }}>
          <button type="submit" className="affiliate-btn affiliate-btn-primary" disabled={saving}>
            {saving ? 'Saving…' : 'Save changes'}
          </button>
        </div>
      </form>
    </div>
  );
}
